import { useState, useEffect, createContext } from "react";
import { getMainView, getViewerView, getSideViewerView, callApi, getBottomViewerView, getCookie, setCookie, loadGoogleMapsAPI, geocodeLatLng, detectCurrentLocationOnWeb } from "./Helpers";
import { useParams } from "react-router-dom";
import Viewer from "./components/Viewer";
import MainBody from "./components/MainBody";
import Backdrop from "./components/Backdrop";
import SideViewer from "./components/SideViewer";
import ConfirmDialog from "./components/ConfirmDialog";
import { ToastContainer, toast } from 'react-toastify';
import SideBar from "./components/SideBar";
import TopBar from "./components/TopBar";
import MainMenuBtn from "./components/MainMenuBtn";
import Launcher from "./views/Launcher";
import OverlayLoader from "./components/OverlayLoader";
import MainLoader from "./components/MainLoader";
import BottomBar from "./components/BottomBar";
import BottomViewer from "./components/BottomViewer";
import MobileInterface from "./MobileInterface";


export const AppContext = createContext(null);

export default function App(props) {

  const [ready, setReady] = useState(false); //for checking if app is ready

  const { _navItem, _navSubItem, _navExtraItem, _navMoreItem } = useParams(); //for routing purposes

  const [navItem, setNavItem] = useState(_navItem); //routing 
  const [navSubItem, setNavSubItem] = useState(_navSubItem); //routing
  const [navExtraItem, setNavExtraItem] = useState(_navExtraItem); //routing
  const [navMoreItem, setNavMoreItem] = useState(_navMoreItem); //routing

  const [showViewer, setShowViewer] = useState(false); //controlling the display of Viewer component
  const [viewerView, setViewerView] = useState(null); //the view to be shown in viewer

  const [showSideViewer, setShowSideViewer] = useState(false); //controlling the display of SideViewer component
  const [sideViewerView, setSideViewerView] = useState(null); //the view to be shown in viewer

  const [showBottomViewer, setShowBottomViewer] = useState(false); //controlling the display of BottomViewer component
  const [bottomViewerView, setBottomViewerView] = useState(null); //the view to be shown in viewer

  const [mainView, setMainView] = useState(null); //the view tobe shown in MainBody

  const [showOverlayLoader, setShowOverlayLoader] = useState(false); //controlling the display of OverlayLoader

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmDialogMessage, setConfirmDialogMessage] = useState("");
  const [confirmDialogAction, setConfirmDialogAction] = useState("");

  const [isSideBarOpen, setIsSideBarOpen] = useState(false); //controls open and close for sidebar in mobile devices

  const [auth, setAuth] = useState(false); //track user authorization status

  //currentSession
  const [currentUserData, setCurrentUserData] = useState(null);
  const [theme, setTheme] = useState('default');
  const [language, setLanguage] = useState(getCookie('language') || 'en');
  const [clientPlatformType, setClientPlatformType] = useState('');

  //location
  const [isLocationPermissionGranted, setIsLocationPermissionGranted] = useState(false);
  const [isLocationSwitchOn, setIsLocationSwitchOn] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [currentLocationString, setCurrentLocationString] = useState(null);

  //App level data
  const [systemParams, setSystemParams] = useState(null);
  const [hotelsFeed, setHotelsFeed] = useState(null);
  const [lodgesFeed, setLodgesFeed] = useState(null);
  const [allRoomOrders, setAllRoomOrders] = useState(null);
  const [allHotelAttributes, setAllHotelAttributes] = useState(null);
  const [allRoomAttributes, setAllRoomAttributes] = useState(null);
  

  async function init() {
    /**
     * Initialize the app here
     */

    setReady(false);

    //get platform type
    await MobileInterface.getClientPlatformType().then((_platform) => {
      setClientPlatformType(_platform);

    })
    

    let locationCheckers = () => {
      checkLocationPermission();
      checkLocationSwitch();
      getCurrentLocation();
    }

    locationCheckers();
    setInterval(() => {
      locationCheckers();
    }, 30000)

    await getSystemParams().then(async _params => {
      
      await Promise.all([
        getAllHotelAttributes(),
        getAllRoomAttributes(),
      ]).catch(() => {
        //..
      });
      

      if (_params) {
        await loadGoogleMapsAPI(_params.mapsApiKey).then(async () => {
          await authCheck().then(async (_auth) => {
            if (_auth) {
              await getCurrentUserData();
            }
          })
        })


        //turn off loaders after initialization
        setReady(true);
      }
    })
  }

  async function checkLocationPermission() {
    if (!isLocationPermissionGranted) {
      await MobileInterface.checkLocationPermission().then(result => {
        setIsLocationPermissionGranted(result);
      });
    }
  }

  async function checkLocationSwitch() {
    if (!isLocationSwitchOn) {
      //check location switch
      let _isEnabled = await MobileInterface.isLocationEnabled();
      setIsLocationSwitchOn(_isEnabled)
    }
  }

  async function getCurrentLocation() {
    
    /*
    const _location = '{ "lat": -6.7865767, "lng": 39.1636192 }';
    const _locationObj = JSON.parse(_location);
    setCurrentLocation(_locationObj);
    return _locationObj;
    */
    
    if (!currentLocation) {
      const _location = await MobileInterface.requestCurrentLocation();

      console.log("CUrrent Location", _location);
      

      try {
        const _locationObj = JSON.parse(_location);
        setCurrentLocation(_locationObj);
        return _locationObj;
      } catch (error) {
        //console.log("Invalid location response", error);
        return null;
      }
    }
      


  }

  function changeLanguage() {
    if (language === 'en') {
      setLanguage('sw');
    } else {
      setLanguage('en');
    }
  }

  function navBack() {
    window.history.back();
    setShowOverlayLoader(false);
  }

  function tellError(msg) {
    toast.error(msg);
  }

  function tellInfo(msg) {
    toast.info(msg);
  }

  function tellWarning(msg) {
    toast.warn(msg);
  }

  function tellMessage(msg) {
    toast.success(msg);
  }

  function refresh() {
    /**
     * This function refreshes the whole app
     */
    window.location.reload(); //remember to optimize
  }

  function navTo(nav) {
    /**
     * This function handles navigation inside the app
     * Utilizing Hash based routing
     * nav is the object supporting the following keys: item, subItem, extraItem, moreItem
     */
    if (nav) {
      //..

      let url = '';
      if (nav.item) {
        url = `#/${nav.item}/`
      }

      if (nav.subItem) {
        url += `${nav.subItem}/`
      }

      if (nav.extraItem) {
        url += `${nav.extraItem}/`
      }

      if (nav.moreItem) {
        url += `${nav.moreItem}/`
      }

      window.location.href = url;
      //..
    }
  }

  function getCurrentUserData() {
    return new Promise(async (resolve, reject) => {
      await callApi('get-current-user-data', {}).then(response => {
        if (response.status === 1) {
          setCurrentUserData(response.data);
          resolve(response.data);
        }
      })
    })
  }


  
  async function getSystemParams() {

    return new Promise(async resolve => {
      await callApi('get-system-params', {}).then(response => {
        if (response.status === 1) {
          setSystemParams(response.data);
          resolve(response.data)
        } else {
          resolve(null)
        }
      })
    })

  }



  function authCheck() {
    return new Promise(async resolve => {
      await callApi('auth-check', {}).then(response => {
        if (response.status === 1) {
          setAuth(true);
          resolve(true)
        } else {
          setAuth(false);
          resolve(false);
        }
      })
    })
  }

  function getHotelsFeed() {
    return new Promise(async (resolve, reject) => {
      await callApi('get-hotels-feed', {}).then(response => {
        if (response.status === 1) {
          setHotelsFeed(response.data);
          resolve(response.data);
        }
      })
    })
  }

  function getLodgesFeed() {
    return new Promise(async (resolve, reject) => {
      await callApi('get-lodges-feed', {}).then(response => {
        if (response.status === 1) {
          setLodgesFeed(response.data);
          resolve(response.data);
        }
      })
    })
  }

  function getAllHotelAttributes() {
    return new Promise(async (resolve, reject) => {
      await callApi('get-all-hotel-attributes', {}).then(response => {
        if (response.status === 1) {
          setAllHotelAttributes(response.data);
          resolve(response.data);
        }
      })
    })
  }

  function getAllRoomAttributes() {
    return new Promise(async (resolve, reject) => {
      await callApi('get-all-room-attributes', {}).then(response => {
        if (response.status === 1) {
          setAllRoomAttributes(response.data);
          resolve(response.data);
        }
      })
    })
  }

  function getAllRoomOrders() {
    return new Promise(async (resolve, reject) => {
      await callApi('get-user-room-orders', {}).then(response => {
        if (response.status === 1) {
          setAllRoomOrders(response.data);
          resolve(response.data);
        }
      })
    })
  }
  
  function getHotelAttributeName(attributeId) {
    let _name = '';

    if(allHotelAttributes) {
      for (const _attribute of allHotelAttributes) {
        if(Number(_attribute.id) === Number(attributeId)) {
          if(language === 'en') {
            _name = _attribute.nameEn;
          } else if(language === 'sw') {
            _name = _attribute.nameSw;
          } else {
            _name = _attribute.nameSws;
          }

          break;
        }
      }
    }

    return _name;
  }

  function getRoomAttributeName(attributeId) {
    let _name = '';

    if(allRoomAttributes) {
      for (const _attribute of allRoomAttributes) {
        if(Number(_attribute.id) === Number(attributeId)) {
          if(language === 'en') {
            _name = _attribute.nameEn;
          } else if(language === 'sw') {
            _name = _attribute.nameSw;
          } else {
            _name = _attribute.nameSws;
          }

          break;
        }
      }
    }

    return _name;
  }
  
  function activateDialog(params) {
    let {
      message,
      onConfirm
    } = params;
    setConfirmDialogAction(() => { return onConfirm });
    setConfirmDialogMessage(message)
    setShowConfirmDialog(true);
  }



  
  useEffect(() => {
    init();
  }, [])

  useEffect(() => {
    if (isSideBarOpen) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }
  }, [isSideBarOpen])

  useEffect(() => {
    setNavItem(_navItem);
    setNavSubItem(_navSubItem);
    setNavExtraItem(_navExtraItem);
    setNavMoreItem(_navMoreItem);
  }, [_navItem, _navSubItem, _navExtraItem, _navMoreItem])

  
  useEffect(() => {
    if (currentUserData) {
      //handle current user data changes here
      //set onesignal Id
      MobileInterface.setOneSignalExternalUserId("avan-real-user-"+currentUserData.id);
    }
  }, [currentUserData])

  useEffect(() => {
    if (currentLocation && currentLocation.lat && currentLocation.lng) {
      geocodeLatLng(currentLocation).then(_locString => {
        if (_locString) {
          setCurrentLocationString(_locString);
        }
      })

      
    }
  }, [currentLocation])


  useEffect(() => {

    //check for viewers
    if (navItem === 'view') {
      //activate viewer
      setShowViewer(true);
      setViewerView(getViewerView(appContext));

      //hide other viewers
      setShowSideViewer(false)
      setSideViewerView(null);

      setShowBottomViewer(false);
      setBottomViewerView(null);

    } else if (navItem === 'side-view') {
      //activate viewer
      setShowSideViewer(true);
      setSideViewerView(getSideViewerView(appContext));

      //hide other viewers
      //setShowViewer(false)
      //setViewerView(null);

      setShowBottomViewer(false);
      setBottomViewerView(null);

    } else if (navItem === 'bottom-view') {
      //activate viewer
      setShowBottomViewer(true);
      setBottomViewerView(getBottomViewerView(appContext));

      //do not hide other views

    } else {
      //just set normal views
      setShowViewer(false);
      setShowSideViewer(false)

      setViewerView(null);
      setSideViewerView(null);

      const _mainView = getMainView(appContext)
      if (_mainView) {
        setMainView(_mainView);
      }
    }
  }, [navItem, navSubItem, navExtraItem, navMoreItem]);

  useEffect(() => {
    setCookie('language', language);
  }, [language])

  const appContext = {
    refresh,
    navTo,
    mainView,
    viewerView,
    setShowOverlayLoader,
    navItem,
    navSubItem,
    navExtraItem,
    navMoreItem,
    setShowViewer,
    showViewer,
    navBack,
    showSideViewer,
    setShowSideViewer,
    sideViewerView,
    activateDialog,
    setShowConfirmDialog,
    confirmDialogAction,
    confirmDialogMessage,
    showConfirmDialog,
    tellError,
    tellInfo,
    tellMessage,
    tellWarning,
    isSideBarOpen,
    setIsSideBarOpen,
    showOverlayLoader,
    auth,
    currentUserData,
    theme,
    language,
    getCurrentUserData,
    bottomViewerView,
    showBottomViewer,
    changeLanguage,
    getSystemParams,
    systemParams,
    setLanguage,
    hotelsFeed,
    getHotelsFeed,
    allRoomOrders,
    getAllRoomOrders,
    getCurrentLocation,
    currentLocation,
    setCurrentLocation,
    currentLocationString,
    checkLocationPermission,
    checkLocationSwitch,
    isLocationPermissionGranted,
    isLocationSwitchOn,
    getAllHotelAttributes,
    getAllRoomAttributes,
    allHotelAttributes,
    allRoomAttributes,
    getRoomAttributeName,
    getHotelAttributeName,
    clientPlatformType,
    getLodgesFeed,
    lodgesFeed,
  }

  if (ready) {
    if (auth) {
      if (currentUserData) {
        return (
          <AppContext.Provider value={appContext}>
            <MainBody />
            <TopBar />
            <BottomBar />
            <Viewer />
            <SideViewer />
            <ConfirmDialog />
            <OverlayLoader />
            <BottomViewer />
            <ToastContainer style={{ zIndex: "var(--maxIndex)" }} position="bottom-right" />
          </AppContext.Provider>
        )
      } else {
        return (
          <AppContext.Provider value={appContext}>
            <ToastContainer style={{ zIndex: "var(--maxIndex)" }} position="bottom-right" />
            <MainLoader />
          </AppContext.Provider>
        )
      }
    } else {
      return (
        <AppContext.Provider value={appContext}>
          <Viewer />
          <OverlayLoader />
          <ToastContainer style={{ zIndex: "var(--maxIndex)" }} position="bottom-right" />
          <Launcher />
        </AppContext.Provider>
      )
    }
  } else {
    return (
      <AppContext.Provider value={appContext}>
        <ToastContainer style={{ zIndex: "var(--maxIndex)" }} position="bottom-right" />
        <MainLoader />
      </AppContext.Provider>
    )
  }
}